import { addPerimeter } from './FarmLayers/perimeter'
import { FolderName } from './Files/plantillaHandle'

export const createArea = (layer, selectedFarmLayer, map, currentFarm) => {
  let newLayer = null
  switch (selectedFarmLayer) {
    case 'perimeter':
      newLayer = addPerimeter(layer, map, currentFarm)
      break
    default:
      // "default case"
      break
  }

  return newLayer
}

export const getPerimeter = map => {
  let perimeter = null
  map.eachLayer(FGLayer => {
    if (FGLayer?.options?.init_info?.farmLayerFG === 'FG_perimeter') {
      FGLayer.eachLayer(layer => {
        perimeter = layer
      })
    }
  })
  return perimeter
}

export const switchCoords = (coords: GeoJSON.Position[]) => {
  const newCoords = []
  coords.forEach(ring => {
    const newRing = []
    ring.forEach(coord => {
      newRing.push([coord[1], coord[0], 0])
    })
    newCoords.push(newRing)
  })
  return newCoords
}

export const getPosibleFolderId = (
  featureProps:
    | {
        id: number
        name: string
        color: string
        type: FolderName
        featureGroup: string
        area: string
      }
    | Record<string, string>,
) => {
  let posibleFolderId: FolderName = 'unassigned'

  const { name, type } = featureProps

  if (type) {
    const typeMap: Record<string, FolderName> = {
      perimeter: 'perimeter',
      perimetro: 'perimeter',
      paddocks: 'paddocks',
      paddock: 'paddocks',
      lote: 'paddocks',
      lotes: 'paddocks',
      estratas: 'estratas',
      estrato: 'estratas',
      strata: 'estratas',
      stratum: 'estratas',
      samplingAreas: 'estratas',
      monitoringSites: 'monitoringSites',
      monitoringSite: 'monitoringSites',
      monitoring: 'monitoringSites',
      monitoring_sites: 'monitoringSites',
      monitoring_site: 'monitoringSites',
      unassigned: 'unassigned',
      unassignedPoints: 'unassignedPoints',
      exclusionAreas: 'exclusion',
      exclusionArea: 'exclusion',
      exclusion: 'exclusion',
      exclusion_areas: 'exclusion',
      exclusion_area: 'exclusion',
    }

    // Layers with no folder of their own (eligibility areas, soc sampling points, project area)
    // must keep the 'unassigned' default: callers index their folder map by this value, and an
    // undefined key aborts the whole import.
    posibleFolderId = typeMap[type] ?? posibleFolderId
  }

  if (posibleFolderId === 'unassigned') {
    const folderNameWords = name?.split(' ') || []
    folderNameWords.forEach(word => {
      const folderName = word.toLowerCase()
      switch (folderName) {
        case 'perimetro':
        case 'perímetro':
        case 'perimeter':
          posibleFolderId = 'perimeter'
          break
        case 'paddocks':
        case 'paddock':
        case 'potreros':
        case 'potrero':
        case 'lote':
        case 'lotes':
          posibleFolderId = 'paddocks'
          break
        case 'estratas':
        case 'estrata':
        case 'stratas':
        case 'strata':
        case 'estratos':
        case 'estrato':
          posibleFolderId = 'estratas'
          break
        case 'mcp':
        case 'mlp':
          posibleFolderId = 'monitoringSites'
          break
        default:
          // keep posibleFolderId value
          break
      }
    })
  }

  return posibleFolderId
}

export const sortAreas = (features: GeoJSON.FeatureCollection) => {
  const newFeatureGroup = features
  newFeatureGroup.features.sort((a, b) => {
    const aArea = a.properties.area.split(' ')[0]
    const bArea = b.properties.area.split(' ')[0]
    return bArea - aArea
  })

  const squaremeters = []
  const hectares = []
  newFeatureGroup.features.forEach(feature => {
    const unit = feature.properties.area.split(' ')[1]
    if (unit === 'm2' || unit === 'm²') {
      squaremeters.push(feature)
    } else if (unit === 'ha') {
      hectares.push(feature)
    }
  })
  newFeatureGroup.features = hectares.concat(squaremeters)

  return newFeatureGroup
}
